import Base from "../Base";
import SendingStatuses from "../../enums/SendingStatuses";
import Attachment from "./Attachment";
import MessagesTypes from "../../enums/MessagesTypes";
import AttachmentsTypes from "../../enums/AttachmentsTypes";
import i18n from "../../../../service/locale/i18";

export default class Message extends Base{
    isSeen;
    /**
     * {string|null}
     */
    id;
    type;
    roomID;
    userID;
    /**
     * {string|null}
     */
    message;
    /**
     * {DateTime|null}
     */
    createdAt;
    localID;
    status;
    attachments = [];

    dates = ['createdAt'];
    integers = ['userID'];
    setDateZone = false;

    constructor(data) {
        super();
        this.setUp(this, data);
        if (this.attachments && this.attachments.length) {
            this.attachments.map(item => new Attachment(item));
        }
    }

    socketData() {
        return {
            roomID: this.roomID,
            message: this.message,
            type: this.type,
            localID: this.localID,
            attachments: this.attachments
        }
    }

    isSending() {
        return this.status == SendingStatuses.sending;
    }

    isError() {
        return this.status == SendingStatuses.error;
    }

    isRegular() {
        return this.type == MessagesTypes.regular || !this.type;
    }

    isIn() {
        return this.type == MessagesTypes.userIn;
    }

    isOut() {
        return this.type == MessagesTypes.userOut;
    }

    hasMeetingAttachment() {
        return this.attachments?.some(item => item.type == AttachmentsTypes.meeting);
    }

    showText() {
        if (this.attachments && Array.isArray(this.attachments)) {
            const noneTextMessages = [AttachmentsTypes.contacts, AttachmentsTypes.meeting];
            return this.attachments.every((item) => !noneTextMessages.includes(item.type));
        }
        return true;
    }

    notificationBody() {
        return this.message.substring(0,70) + (this.message.length > 70 ? '...' : '');
    }

    notificationBodyIn(userName) {
        return `${userName} ${i18n.t('common.chat joined')}`;
    }

    notificationBodyOut(userName) {
        return `${userName} ${i18n.t('common.chat left')}`;
    }
}
